import React, { useContext, useEffect } from 'react'
import * as THREE from "three";
import LoadMap from './LoadMap'
import LoadPath from './LoadPath';
import { useThree } from '@react-three/fiber';

function LoadScene() {
    let {camera,gl} = useThree()

   
// set compass position
useEffect(() => {
  var dir = new THREE.Vector3();
  var sph = new THREE.Spherical();
  let compass = document.getElementById('compassContainer')
  if(camera && gl) {
    gl.setAnimationLoop(() => {
      camera.getWorldDirection(dir);
      sph.setFromVector3(dir);
      // compass.style.transform = `rotate(${THREE.MathUtils.radToDeg(sph.theta) - 180}deg)`;
    });
  }
  
}, [camera, gl])

  return (
   <>
    <LoadMap />
     <LoadPath  /> 
   </>
  )
}

export default LoadScene